import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
interface LayoutProps {
  children: React.ReactNode;
}
const Layout: React.FC<LayoutProps> = ({
  children
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  return <div className="flex h-screen w-full bg-gradient-to-br from-[#0A0E17] via-[#0F1419] to-[#0A0E17] text-gray-100 overflow-hidden" data-id="element-59">
      <Sidebar isOpen={sidebarOpen} isCollapsed={sidebarCollapsed} onClose={() => setSidebarOpen(false)} onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)} data-id="element-60" />
      {/* Mobile overlay */}
      {sidebarOpen && <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-30 lg:hidden" onClick={() => setSidebarOpen(false)} data-id="element-61" />}
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-62">
        <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)} sidebarCollapsed={sidebarCollapsed} data-id="element-63" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-64">
          <div className="max-w-[1920px] mx-auto" data-id="element-65">{children}</div>
        </main>
      </div>
    </div>;
};
export default Layout;